import { RemoteControlQuestionsService, RemoteUsersService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

export const usersService = new RemoteUsersService(httpClient)
export const controlQuestionsService = new RemoteControlQuestionsService(httpClient)
